<template>
    <Link method="get" :href="route('play')" :class="button" class="right-0 bottom-0 fixed inline-flex justify-center items-center border border-transparent font-medium text-white font-semibold
            bg-gray-800 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-700 m-4 transition duration-500 ease-in-out dark:bg-racing-stars-yellow dark:text-gray-800">
    Play Now
    </Link>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3';

export default {
    props: {
        xs: Boolean,
        sm: Boolean,
        lg: Boolean,
        xl: Boolean,
    },

    components: {
        Link,
    },

    computed: {
        button() {
            return {
                'px-2.5 py-1.5 text-xs rounded': this.xs,
                'px-3 py-2 text-sm leading-4 rounded-md': this.sm,
                'px-4 py-2 text-sm rounded-md': !this.xs && !this.sm && !this.lg && !this.xl,
                'px-4 py-2 text-base rounded-md': this.lg,
                'px-6 py-3 text-base rounded-md': this.xl,
            }
        }
    }
}

</script>
